import { IClickEventData } from 'types/analytics';

export const TEXT_KEYS = {
    LEGAL_TAGLINE: 'platform-selection__disclaimer'
};

export const LEGAL_TAG_ANALYTICS_ATTRIBUTES: IClickEventData = {
    location: 'Page',
    category: 'Interaction',
    action: 'Legal opt-in'
};
